<template>
  <v-card>
    <v-card-title v-if="options.title">
      <span class="headline">{{ options.title }}</span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
       <ValidationObserver
        ref="form"
        tag="form"
        @submit.prevent="save"
      >
        <ValidationProvider
            rules="required"
            vid="object"
            :name="$t('fields.mail_subject').toLowerCase()"
            v-slot="{ errors }"
        >
          <v-text-field
            v-model=" form.object"
            :counter="30"
            :label="$t('fields.mail_subject')"
            :error-messages="errors"
          ></v-text-field>
        </ValidationProvider>
        <ValidationProvider
            rules="required"
            vid="body"
            :name="$t('fields.body').toLowerCase()"
            v-slot="{ errors }"
        >
          <v-textarea
            v-model="form.body"
            :label="$t('fields.body')"
            :hint="$t('fields.body')"
            :error-messages="errors"
          ></v-textarea>
        </ValidationProvider>
    </ValidationObserver>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="save" color="primary">{{ $t('SEND') }}</v-btn>
      <v-btn @click="cancel">{{ $t('CANCEL') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
  import { mapActions, mapState } from 'vuex';

  export default {
    name: 'CommunicationModal',
    data() {
      return {
        stored: null,
        form: {
          emails: [],
          object: null,
          body: null,
        },
        loading: false,
      };
    },
    computed: {
      ...mapState('modal', ['options', 'data']),
    },
    methods: {
      ...mapActions('alert', ['showToast']),
      ...mapActions('modal', ['hideModal', 'loadingModal']),
      async save() {
        const isValid = await this.$refs.form.validate();
        if (isValid) {
            if (this.options.onSave) {
              this.loadingModal(true);
              this.options.onSave(
                this.form,
                this.errors,
              )
              .then(() => {
                  this.loadingModal(false);
              })
              .catch(error => {
                  this.handleError(error, this.errors);
              });
            }
        }
      },
      cancel() {
        this.hideModal({});
      },
    },
    async created() {
      this.loadingModal(true);
      if (this.data.stored) {
        this.form.emails = this.data.stored.emails;
      }
      this.loadingModal(false);
    },
  };
</script>
